export enum ContentType {
  Product = "product",
  ProductPage = "product_page",
  ProductPageBlock = "product_page_block",
  ProductPages = "product_pages",
}

export enum ContentTypeIds {
  Product = "46",
  ProductPage = "74",
  ProductPageBlock = "69",
  ProductPages = "75",
}
